/**
 * Distribution de référence par groupe — **fichier produit, ne pas modifier à la main.**
 *
 * Chaque tableau contient l'indice d'exposition des professions CITP-08 du
 * groupe, ramené une par une sur notre échelle 0–100 par la formule qui donne
 * les bases :
 *
 *   indice = arrondi( 100 × (score OIT − 0,09) / (0,70 − 0,09) )
 *
 * Ce que c'est : les 427 professions publiées par l'OIT, réparties dans nos
 * onze groupes. Ce que ce n'est pas : des personnes. Un repère tiré d'ici se
 * dit « professions recensées », jamais « profils analysés » — la comparaison
 * entre confrères, elle, attend ses 200 diagnostics réels.
 *
 * Régénérer par `node scripts/deriver-bases.mjs --reference`.
 * `reference.test.ts` refait la dérivation et échoue en cas d'écart.
 */
export const REFERENCE_OIT = {
    ADMIN: [38, 44, 46, 46, 52, 54, 56, 56, 57, 59, 61, 66, 67, 69, 74, 80, 80, 84, 89, 92, 100],
    COMMERCIAL: [21, 25, 25, 26, 43, 43, 44, 48, 49, 49, 54, 54, 56, 57, 57, 59, 61, 64, 66, 67, 69, 69, 72, 74, 75, 77, 79, 79, 79, 80, 85],
    COMPTA: [56, 59, 64, 66, 69, 79, 80, 84, 85, 87, 89, 90, 90],
    CREA: [7, 16, 20, 31, 36, 43, 43, 46, 46, 46, 49, 56, 62, 66, 74, 75, 75, 82],
    DIRECTION: [21, 23, 30, 34, 36, 38, 41, 41, 43, 44, 44, 44, 44, 44, 46, 46, 46, 46, 48, 48, 48, 48, 48, 49, 51, 52, 54, 57, 57, 61, 62],
    ENSEIGNEMENT: [18, 20, 25, 26, 28, 31, 34, 39, 41, 43, 43, 43, 46, 46, 49, 62],
    IT: [56, 56, 62, 66, 66, 70, 72, 72, 75, 77, 79, 79, 79, 79, 84],
    JURIDIQUE: [36, 44, 46, 49, 75],
    RH: [49, 52, 59, 84],
    SANTE: [5, 8, 8, 8, 10, 10, 11, 13, 13, 15, 16, 16, 18, 18, 21, 21, 21, 21, 23, 25, 25, 25, 25, 26, 26, 30, 31, 31, 31, 33, 34, 34, 34, 36, 38, 39, 39, 43, 49, 52, 70],
    TERRAIN: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 2, 2, 3, 3, 3, 3, 3, 3, 3, 3, 3, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 10, 10, 10, 10, 10, 10, 10, 11, 11, 11, 11, 11, 11, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 16, 16, 16, 16, 16, 16, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 20, 20, 20, 20, 20, 20, 20, 20, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 23, 23, 23, 23, 25, 25, 25, 26, 26, 26, 26, 26, 28, 28, 28, 28, 28, 28, 30, 30, 30, 30, 30, 30, 31, 31, 31, 31, 31, 31, 31, 31, 33, 33, 33, 33, 33, 33, 33, 34, 34, 34, 36, 36, 36, 36, 36, 38, 38, 38, 38, 41, 43, 43, 43, 44, 46, 46, 46, 46, 48, 48, 48, 48, 48, 48, 48, 49, 51, 52, 54, 57, 59, 62, 62, 64, 64, 72, 74, 75, 75],
};
/**
 * Combien de professions l'OIT note — **dérivé, jamais recopié.**
 *
 * L'accueil en fait l'un de ses trois seuls chiffres. Il le saisissait à la
 * main, à côté de l'écart des bases qui, lui, avait fini par mentir : le
 * barème avait changé, la page non. Un chiffre publié se lit désormais d'ici.
 */
export const PROFESSIONS_NOTEES = Object.values(REFERENCE_OIT).reduce((total, groupe) => total + groupe.length, 0);
